import { useEffect, useState } from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loginUser } from "../../store/reducers/auth";
import { jwtValidateApi } from "../../Services/authService";

export const AuthGuard = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [authChecked, setAuthChecked] = useState(false);

  const checkAuth = async () => {
    const urlParams = new URLSearchParams(location.search);
    const tokenFromUrl = urlParams.get("token");
    const sourceUrl = urlParams.get("source");
      if (tokenFromUrl) {
        const response = await jwtValidateApi(tokenFromUrl);
        if (response.status === 200) {
          const userData = response.data;
          const userRole = userData?.user?.role?.name?.trim()?.toLowerCase();
          if (userRole === "admin" || userRole === "vkyc auditor") {
            dispatch(loginUser(userData));
            // const cleanUrl = window.location.origin + "/";
            // window.history.replaceState({}, document.title, cleanUrl);
            sessionStorage.setItem("source", sourceUrl);
            setAuthChecked(true);
            navigate("/vkyc/dashboard", { replace: true });
            return;
          }else{
            window.location.href = `${sourceUrl || "http://localhost:3000"}/login`;
          }
        } else {
          window.location.href = `${sourceUrl || "http://localhost:3000"}/login`;
        }
      }
      const loggedIn = sessionStorage.getItem("isLogged");
 
      if (!loggedIn) {
        if (location.pathname !== "/vkyc/login"){
          navigate("/vkyc/login", { replace: true });
        }
      } else {
        setAuthChecked(true);
      }
  };

  useEffect(() => {
    checkAuth();

    const handlePopState = () => {
      checkAuth();
    };

    window.addEventListener("popstate", handlePopState);
 
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);
 
  useEffect(() => {
    checkAuth();
  }, [location]);

  if (!authChecked) return null;

  return <Outlet />;;
};